import { useState } from "react";
import useCreate from '../../useCreate';
import toast from 'react-hot-toast';

const useDeleteProductConcern = () => {
  const [concernId, setConcernId] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

  const { setDataToServer } = useCreate({
    url: 'concern/delete',
    refreshUrl: 'concern/list',
    onSuccess: () => {
      toast.success("Concern Deleted Successfully", {
        position: "top-right",
        duration: 3000
      });
      setDeleteModalOpen(false);
    }
  });

  const handleSubmit = (data) => {
    setDataToServer.mutate(data);
  };

  return {
    concernId,
    setConcernId,
    isDeleteModalOpen,
    setDeleteModalOpen,
    handleSubmit,
  };
};

export default useDeleteProductConcern;
